import { render, staticRenderFns } from "./SupplierRightsAndObligationsOutput.vue?vue&type=template&id=bb64910a&"
import script from "./SupplierRightsAndObligationsOutput.vue?vue&type=script&lang=js&"
export * from "./SupplierRightsAndObligationsOutput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/apps/eneforhandler/components/contract/SupplierRightsAndObligationsOutput.vue
// module id = null
// module chunks = 